<div #menuContainer
    role="menu"
    class="card flex flex-col p-0 md:py-3 md:px-2 md:bg-black/80 overflow-hidden md:backdrop-blur-md pointer-events-auto opacity-0"
    [style.max-height]="isShortViewport ? 'none' : '64dvh'"
    [class]="{'hidden': hideElement()}"
    [attr.aria-hidden]="hideElement()"
>

   <!-- OUTER WRAPPER -->
   <div #menuItems class="scrollBox h-full overflow-y-auto">

        <!-- MENU TITLE (ONLY MOBILE) -->
        <div class="p-2 mb-3.5 direction-ltr">
            <div class="flex items-baseline">
                <h3 class="md:hidden font-semibold text-lg text-left mr-2 text-white">
                    {{ Title }}
                </h3>
                <span class="inline-block text-xs font-normal"  [class]="isVip ? 'text-vip' : 'text-gray-400'">
                    {{AvailableLabel}}
                </span>
            </div>
        </div>

        <ul class="flex flex-col gap-y-3" role="menu">

            @for (item of menuContents; track item.data.id) {

                <li role="menuitem" class="min-w-[248px]">
                    <app-menu-item [item]="item"/>
                </li>

            }

        </ul>

    </div>

</div>
